import { z } from "zod";
import { organizationBankAccountSchema } from "./organization-bank-account";
export const organizationTypeSchema = z.enum(["provider", "concierge"]);
export const organizationRoleKeySchema = z.enum([
    "provider_owner",
    "provider_admin",
    "provider_staff",
    "concierge_owner",
    "concierge_admin",
    "concierge_staff",
]);
export const ownerUserSchema = z.object({
    dni: z.string().min(1),
    company_name: z.string().min(1),
    assigned_person: z.string().min(1),
    email: z.string().email(),
    contact_phone: z.string().optional().nullable(),
    country: z.string().min(2),
    location_one: z.string().min(1),
    location_two: z.string().min(1),
    password: z.string().min(8),
    ip_address: z.string().optional(),
    image_storage_id: z.number().int().positive().optional().nullable(),
});
export const providerProfileSchema = z.object({
    dni: z.string().min(1),
    name: z.string().min(1),
    primary_contact: z.string().min(1),
    second_contact: z.string().optional().nullable(),
    email: z.string().email(),
    location_one: z.string().min(1),
    location_two: z.string().min(1),
    location_three: z.string().optional().nullable(),
    country: z.string().min(2),
    country_name: z.string().optional().nullable(),
    description: z.string().min(1),
});
export const organizationBillingDiscountSchema = z.object({
    type: z.enum(["percentage", "fixed_amount", "credit"]),
    percentage_bps: z.number().int().positive().optional(),
    amount_minor: z.number().int().positive().optional(),
    currency: z.string().optional(),
    reason: z.string().min(1),
});
export const organizationBillingSetupSchema = z
    .object({
    plan_id: z.string().min(1),
    plan_price_id: z.string().min(1),
    payment_method_type: z.enum(["onvo_card", "manual_transfer", "manual_other"]),
    trial: z.object({
        enabled: z.boolean(),
        days: z.number().int().positive().nullable().optional(),
    }),
    grace_days_after_due: z.number().int().min(0),
    discounts: z.array(organizationBillingDiscountSchema).optional(),
})
    .refine((value) => !value.trial.enabled || Boolean(value.trial.days), "Los días de prueba son requeridos cuando aplica prueba");
export const createOrganizationSchema = z
    .object({
    display_name: z.string().min(1),
    org_type: organizationTypeSchema,
    owner: ownerUserSchema,
    provider_profile: providerProfileSchema.optional(),
    bank_accounts: z.array(organizationBankAccountSchema).min(1).optional(),
    billing_setup: organizationBillingSetupSchema.optional(),
})
    .refine((value) => value.org_type === "concierge" || !!value.provider_profile, "Las organizaciones proveedor requieren perfil de proveedor")
    .refine((value) => value.org_type !== "concierge" || !!value.billing_setup, "Las organizaciones concierge requieren configuración de facturación");
export const defaultOwnerUserValues = {
    dni: "",
    company_name: "",
    assigned_person: "",
    email: "",
    contact_phone: "",
    country: "CR",
    location_one: "",
    location_two: "",
    password: "",
    ip_address: "127.0.0.1",
    image_storage_id: null,
};
export const defaultProviderProfileValues = {
    dni: "",
    name: "",
    primary_contact: "",
    second_contact: "",
    email: "",
    location_one: "",
    location_two: "",
    location_three: "",
    country: "CR",
    country_name: "",
    description: "",
};
